import React, { useState } from "react";
import "./Auth.css";
import Logo from "../../img/logo.png";

const Auth = () => {
  const [isLogin, setIsLogin] = useState(true);

  const toggleForm = () => {
    setIsLogin(!isLogin);
  };

  return (
    <div className="Auth">
      <div className="a-left">
        <img src={Logo} alt="Logo" className="logo" />
        <div className="Webname">
          <h1>Okwe Nick Platform</h1>
          <h6>Explore ideas from around the world</h6>
        </div>
      </div>

      {isLogin ? <LogIn toggleForm={toggleForm} /> : <SignUp toggleForm={toggleForm} />}
    </div>
  );
};

function LogIn({ toggleForm }) {
  return (
    <div className="a-right">
      <form className="infoForm authForm">
        <h3>Log In</h3>

        <div className="form-group">
          <input
            type="text"
            placeholder="Username"
            className="infoInput"
            name="username"
          />
        </div>

        <div className="form-group">
          <input
            type="password"
            className="infoInput"
            placeholder="Password"
            name="password"
          />
        </div>

        <div className="form-actions">
          <span className="text-small">
            Don't have an account?{" "}
            <button className="button infoButton" onClick={toggleForm}>
              Sign up
            </button>
          </span>
          <button className="button primaryButton">Login</button>
        </div>
      </form>
    </div>
  );
}

function SignUp({ toggleForm }) {
  return (
    <div className="a-right">
      <form className="infoForm authForm">
        <h3>Sign up</h3>

        <div className="form-group">
          <input
            type="text"
            placeholder="First Name"
            className="infoInput"
            name="firstname"
          />
          <input
            type="text"
            placeholder="Last Name"
            className="infoInput"
            name="lastname"
          />
        </div>

        <div className="form-group">
          <input
            type="text"
            className="infoInput"
            name="username"
            placeholder="Username"
          />
        </div>

        <div className="form-group">
          <input
            type="password"
            className="infoInput"
            name="password"
            placeholder="Password"
          />
          <input
            type="password"
            className="infoInput"
            name="confirmpass"
            placeholder="Confirm Password"
          />
        </div>

        <div className="form-actions">
          <span className="text-small">
            Already have an account?{" "}
            <button className="button infoButton" onClick={toggleForm}>
              Login
            </button>
          </span>
          <button className="button primaryButton" type="submit">
            Signup
          </button>
        </div>
      </form>
    </div>
  );
}

export default Auth;
